export default "__VITE_ASSET__288d78c0__"